import React from 'react';
import SecondaryActionBar from '../../../ActionBar/SecondaryActionBar';
export var SecondaryActionBarWrapper = function (_a) {
    var children = _a.children, deviation = _a.deviation, withSecondaryActionBar = _a.withSecondaryActionBar, className = _a.className;
    return withSecondaryActionBar ? (React.createElement(SecondaryActionBar, { deviation: deviation, wrapperClassName: className }, children)) : (React.createElement(React.Fragment, null, children));
};
SecondaryActionBarWrapper.displayName = 'SecondaryActionBarWrapper';
export default SecondaryActionBarWrapper;
//# sourceMappingURL=SecondaryActionBarWrapper.js.map